import { render, staticRenderFns } from "./MarketingLeadKanbanView.vue?vue&type=template&id=ff3477c2"
import script from "./MarketingLeadKanbanView.vue?vue&type=script&lang=js"
export * from "./MarketingLeadKanbanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports